<script>
import leave from "@/mixins/leave";
import labService from "@/services/lab";

export default {
  name: "ModalLab",
  mixins: [leave],

  props: {
    showDialogModal: {
      type: Boolean,
    },
    currentLab: {
      type: Object,
    },
  },

  data() {
    return {
      isPosting: false,
      lab: {
        code: null,
        description: "",
        isActive: true,
      },
      isUpdate: !!this.currentLab?._id,
      isShowed: this.showDialogModal,
    };
  },

  created() {
    if (this.isUpdate) {
      this.lab = { ...this.currentLab };
    }
  },

  mounted() {
    document.addEventListener("keyup", this.escape);
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.escape);
  },

  methods: {
    escape(event) {
      if (event.keyCode == 27) this.close();
    },

    submit() {
      if (this.isUpdate) {
        this.updateLab();
      } else {
        this.createLab();
      }
    },

    createLab() {
      this.isPosting = true;

      labService
        .createLab(this.lab)
        .then((lab) => {
          this.$bus.$emit("lab-created", lab);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    updateLab() {
      this.isPosting = true;

      labService
        .updateLab(this.lab._id, this.lab)
        .then((lab) => {
          this.$bus.$emit("lab-updated", lab);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    close() {
      this.isPosting = false;
      this.isShowed = false;
      this.$emit("close");
    },
  },
};
</script>

<template lang="pug">
el-dialog(name="modal-lab", :visible.sync="isShowed", :before-close="close", :title="isUpdate ? 'Editar laboratorio' : 'Nuevo laboratorio'")
  .el-dialog__body
    ValidationObserver(v-slot="{handleSubmit}")
      form(@submit.prevent="handleSubmit(submit)")
        label.label * Código
        ValidationProvider(name="Código" rules="required|numeric" v-slot="{ errors }")
          el-input(v-model.number="lab.code" type="number")
          span.has-error {{ errors[0] }}

        label.label * Descripción
        ValidationProvider(name="Descripción" rules="required" v-slot="{ errors }")
          el-input(v-model="lab.description")
          span.has-error {{ errors[0] }}

        label.label Estado
        el-checkbox(v-model="lab.isActive")
          | Laboratorio activo

        span(v-if="isUpdate")
          label.label ID
          el-input(v-model="lab._id" readonly)

  .el-dialog__footer
    el-button.button(type="info" @click="close()") Cancelar
    el-button.button(type="primary" :loading="isPosting" @click="submit") Guardar
</template>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 0 20px 20px 20px;
}

.label {
  margin-top: 10px;
}

.modal {
  z-index: 9999;
}

.el-dialog__footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  .button {
    margin: 0;
  }
}
</style>
